import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-register-as',
  templateUrl: './register-as.component.html',
  styleUrls: ['./register-as.component.css']
})
export class RegisterAsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
